// Size Banner logic (collection-existence driven; supports multiple section instances)
(function () {
  function initContainer(container) {
    if (!container || container.dataset.inited === "1") return;
    container.dataset.inited = "1";

    var select  = container.querySelector(".bfm-select");
    var braBtn  = container.querySelector("[data-bfm-bra-btn]");
    var swimBtn = container.querySelector("[data-bfm-swim-btn]");
    var errorEl = container.querySelector(".bfm-error");

    // Map for THIS section instance
    var sectionId = container.getAttribute("data-section-id") || "";
    var availabilityAll = window.bfmSizeAvailability || {};
    var map = availabilityAll[sectionId] || {};

    function hideError(){ if (errorEl) errorEl.style.display = "none"; }
    function showError(msg){
      if (!errorEl) return;
      errorEl.textContent = msg || "Please select your size";
      errorEl.style.display = "block";
    }

    function setEnabled(btn, url){
      if (!btn) return;
      btn.setAttribute("aria-disabled", "false");
      btn.setAttribute("href", url || "#");
      btn.removeAttribute("data-requires-selection");
      btn.tabIndex = 0;
    }
    function setDisabled(btn){
      if (!btn) return;
      btn.setAttribute("aria-disabled", "true");
      btn.removeAttribute("href");
      btn.removeAttribute("data-requires-selection");
      btn.tabIndex = -1;
    }
    function setNeedsSelection(btn){
      if (!btn) return;
      btn.setAttribute("aria-disabled", "false");   // looks enabled pre-selection
      btn.setAttribute("href", "#");                // safe placeholder
      btn.setAttribute("data-requires-selection", "1");
      btn.tabIndex = 0;
    }

    function syncForSelection(){
      var size = (select && select.value) ? select.value : "";

      if (!size) {
        container.setAttribute("data-has-selection", "0");
        setNeedsSelection(braBtn);
        setNeedsSelection(swimBtn);
        return;
      }

      container.setAttribute("data-has-selection", "1");
      var entry  = map[size] || {};
      var braOk  = !!(entry.bra  && entry.bra_url);
      var swimOk = !!(entry.swim && entry.swim_url);

      if (braOk)  setEnabled(braBtn,  entry.bra_url);  else setDisabled(braBtn);
      if (swimOk) setEnabled(swimBtn, entry.swim_url); else setDisabled(swimBtn);
    }

    // Intercept clicks safely
    [braBtn, swimBtn].forEach(function(btn){
      if (!btn) return;
      btn.addEventListener("click", function(e){
        // If disabled after selection, block
        if (btn.getAttribute("aria-disabled") === "true") {
          e.preventDefault();
          return;
        }
        // If no selection yet, show helper
        if (btn.getAttribute("data-requires-selection") === "1") {
          e.preventDefault();
          showError("Please select your size");
          try { select && select.focus(); } catch(_) {}
        }
      }, true);
    });

    if (select) {
      select.addEventListener("change", function(){
        hideError();
        syncForSelection();
      });
    }

    // Init
    hideError();
    syncForSelection();
  }

  function initAll(root) {
    (root || document).querySelectorAll(".bfm-size-banner").forEach(initContainer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function(){ initAll(document); });
  } else {
    initAll(document);
  }

  // Theme Editor dynamic loads
  document.addEventListener("shopify:section:load", function(e){ initAll(e.target); });
})();
